<template>
  <div>
    <!-- Voice Search -->
    <div class="mdc-layout-grid demo-grid section-privacy-security">
      <h3
        id="feature6"
        class="feature mdc-typography--headline3 text-color mb-3"
      >
        Căutare vocală
      </h3>
      <p data-scroll class="mdc-typography--body text-color font-weight-bold">
        Căutarea vocală ajută persoanele cu dizabilități să caute mai ușor
      </p>
      <div class="mdc-layout-grid__inner">
        <!-- ROW 1-->
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content py-5 always-white">
            <h6
              class="mdc-typography--headline6 text-color zindex-dropdown position-relative"
              style="z-index:3;"
            >
              Nou Căutare vocală
            </h6>
            <p class="typography-phrase position-relative" style="z-index:3;">
              <span class="word" data-aos="fade" data-aos-duration="300"
                >Surfverse
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="300"
                data-aos-delay="300"
                >are
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="300"
                data-aos-delay="600"
                >o
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="300"
                data-aos-delay="800"
                >nouă
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="300"
                data-aos-delay="1000"
                >modalitate
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="300"
                data-aos-delay="1200"
                >pentru
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="300"
                data-aos-delay="1400"
                >a
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="300"
                data-aos-delay="1600"
                >căuta
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="300"
                data-aos-delay="1800"
                >folosind
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="300"
                data-aos-delay="2000"
                >tehnologia
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="300"
                data-aos-delay="2200"
                >Google Voice
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="300"
                data-aos-delay="2400"
                >Search.
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="300"
                data-aos-delay="2600"
                >Totul
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="300"
                data-aos-delay="2800"
                >devine
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="300"
                data-aos-delay="2900"
                >mai
              </span>
              <span
                class="word"
                data-aos="fade"
                data-aos-duration="300"
                data-aos-delay="3000"
                >simplu.</span
              >
            </p>
            <!-- <figure class="image-feature1-item1" role="img"></figure> -->
            <figure
              class="front-panel-bgimage image-new-surfverse-voice progressive-image-animated"
              data-progressive-image-loaded
            ></figure>
            <div class="backdrop-filter" style="z-index:2;"></div>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">Public profile</h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              Introducing public and private profiles designed around security
              and privacy.
            </p>
            <figure class="image-feature1-item1" role="img"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">Public profile</h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              Introducing public and private profiles designed around security
              and privacy.
            </p>
            <figure class="image-feature1-item1" role="img"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <!-- END ROW 1 -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  Search: 'Search'
}
</script>

<style>
.typography-phrase {
  max-width: 950px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 182px;
  margin-bottom: 107px;
  text-align: center;
}
.word {
  font-size: 56px;
  line-height: 1.07143;
  font-weight: 700;
  letter-spacing: -0.005em;
  font-family: 'SF Pro Display', 'SF Pro Icons', 'Helvetica Neue', 'Helvetica',
    'Arial', sans-serif;
  position: relative;
}
.front-panel-bgimage {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 840px;
  margin: 0;
  background-position-y: top;
  background-position-x: center;
}

.image-new-surfverse-voice {
  width: 100%;
  height: 100%;
  background-size: auto;
  background-repeat: no-repeat;
  background-image: url(/img/search/surfing.jpg);
  background-position: bottom;
}
.backdrop-filter {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  left: 0;
  background: rgba(0, 0, 0, 0.35);
  /* backdrop-filter: saturate(180%) blur(20px); */
}
</style>
